import React, { Fragment, useEffect } from "react";
import { MONGOURL, SVCURL } from "@data/GlobalData.js";
import { useGenericStore } from "@customHooks/useGenericStore.js";
import { PROCESS_DELETE } from "@genericComponents/CFW.js";
import { Clone } from "@genericComponents/Common.js";
import { PostData } from "@genericComponents/SFW.js";
import { GetState, RemoveState } from "@genericComponents/StoreToolkit.js";
const GenerateStateEntry =
  await import("@asyncImports/GenerateStateEntry.js").then(
    (mod) => mod.GenerateStateEntry,
  );
const MatchingFieldsOnly =
  await import("@asyncImports/MatchingFieldsOnly.js").then(
    (mod) => mod.MatchingFieldsOnly,
  );
const ProcessChildren = () => {
  const CFW_PROCESS_CHILD_ID = "PROCESS_CHILD_ID";
  const childrenParam = useGenericStore(CFW_PROCESS_CHILD_ID);
  const ClearWindowParams = () => {
    RemoveState(CFW_PROCESS_CHILD_ID);
    if (window?.processing) {
      delete window.processing;
    }
  };
  const BeginProcess = () => {
    const childData = GenerateStateEntry(
      childrenParam.Response,
      childrenParam.Param,
      "childrenEntry",
    );
    const DeleteChildren = () => {
      const param = Clone(childData.entry.param);
      param.Process = PROCESS_DELETE;
      param[childrenParam.ColumnGroup] = childrenParam.Id;
      PostData(
        [MONGOURL, childrenParam.Service].join(""),
        param,
        childrenParam.Response,
        () => {
          RemoveState(childData.list.state);
          ClearWindowParams();
        },
      );
    };

    useEffect(() => {
      if (!window.processing) {
        window.processing = true;
        if (childrenParam.Process === PROCESS_DELETE) {
          DeleteChildren();
        } else {
          const childList = GetState(childData.list.state, []);
          const childToProcess = childList?.length
            ? [...childList].filter((item) => item?.Process)
            : [];
          if (!childToProcess?.length) {
            ClearWindowParams();
          } else {
            const results = childToProcess.map(async (currentChild) => {
              return new Promise((resolve) => {
                const param = MatchingFieldsOnly(
                  currentChild,
                  childData.entry.param,
                );
                param[childrenParam.ColumnGroup] = childrenParam.Id;
                PostData(
                  [SVCURL, childrenParam.Service].join(""),
                  param,
                  childrenParam.Response,
                  () => {
                    resolve(true);
                  },
                );
              });
            });
            Promise.all(results).then(() => {
              ClearWindowParams();
            });
          }
        }
      }
      return () => {};
    }, [childrenParam]);
    return <Fragment />;
  };
  return childrenParam ? <BeginProcess /> : <Fragment />;
};
export default ProcessChildren;
